import React, { useState, useCallback } from 'react';
import { useMutation } from '@apollo/react-hooks';
import {
  Form, FormGroup, Label, Input, Button, Container, Row, Col,
} from 'reactstrap';
import { TRANSFER_BOX_HISTORY } from '../../mutation/mutation';

const requestStatus = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  FAIL: 'fail',
};

const TransferBoxHistory = () => {
  const [fromMac, setFromMac] = useState('');
  const [toMac, setToMac] = useState('');
  const [isSuccess, setIsSuccess] = useState(requestStatus.DEFAULT);
  const [savTransferBoxHistory] = useMutation(TRANSFER_BOX_HISTORY);

  const handleClick = useCallback(
    async (e) => {
      e.preventDefault();
      if (fromMac === '' || toMac === '') {
        setIsSuccess(requestStatus.DEFAULT);
      // eslint-disable-next-line no-alert
      } else if (window.confirm(`Transfer messages history from ${fromMac} to ${toMac} ?`)) {
        try {
          await savTransferBoxHistory({ variables: { fromBoxMAC: fromMac, toBoxMAC: toMac } });
          setIsSuccess(requestStatus.SUCCESS);
        } catch (err) {
          setIsSuccess(requestStatus.FAIL);
        }
      }
    },
    [fromMac, toMac],
  );

  return (
    <Form onSubmit={handleClick}>
      <FormGroup>
        <Label>FROM box</Label>
        <Container>
          <Row>
            <Col>
              <Input
                type="text"
                placeholder="MAC address"
                value={fromMac}
                onChange={({ target: { value } }) => setFromMac(value)}
              />
            </Col>
            <Col />
          </Row>
        </Container>
        <Label>TO Box</Label>
        <Container>
          <Row>
            <Col>
              <Input
                type="text"
                placeholder="MAC address"
                value={toMac}
                onChange={({ target: { value } }) => setToMac(value)}
              />
            </Col>
            <Col>
              <Button
                type="submit"
                color="danger"
              >
                Validate
              </Button>
            </Col>
          </Row>
        </Container>
      </FormGroup>
      { isSuccess === requestStatus.SUCCESS
        ? <Label>Box history successfully transferred</Label> : <Label />}
      { isSuccess === requestStatus.FAIL
        ? <Label>Error: Please check there is no typo in the mac addresses</Label> : <Label />}
    </Form>
  );
};

export default TransferBoxHistory;



// WEBPACK FOOTER //
// ./src/components/lovebox-info/transfer-box-history.js